import React from 'react';

import { OPTION_FONT_TO_CSS_CLASS } from '../../group/customsignup/signature/components/FontSelector';

const FullScreenSelectManyOption = ({
    target,
    value,
    selected,
    handleClick,
    label,
    renderFont,
}) => {
    return (
        <button
            type="button"
            onClick={() => handleClick(target, value)}
            value={value}
            name={target}
            // Add 'selected' class to visually indicate the selected state
            className={`overlay-menu-linkblock not-primary w-inline-block button-reset ${selected ? 'selected' : ''}`}
        >
            <div className="flex-center">
                <div className={renderFont ? `${OPTION_FONT_TO_CSS_CLASS[value]} text-[25px]` : ''}>
                    {label}
                </div>
            </div>
            {/* Use a different class for the selector based on the selected state */}
            <div
                className={`menu-link-selector ${selected ? 'selected-menu-link-selector' : ''}`}
            />
        </button>
    );
};

export default FullScreenSelectManyOption;